import { useContextQuery } from './use-context-query';

/**
 * Returns true when the current user has the given capability key.
 *
 * The key may be a role permission code (e.g. 'offer.view') or a
 * feature-flag capability key (e.g. 'offer-drafts', 'availability-calendar').
 *
 * Returns true (fail-open) while context is loading (data is undefined) —
 * the server is the authoritative enforcement point.
 * Returns false only when context is loaded and the key is absent.
 */
export function useHasPermission(
  key: string,
  options: { loading?: 'open' | 'closed' } = {},
): boolean {
  const { data } = useContextQuery();
  if (data == null) return options.loading !== 'closed'; // not yet loaded — optimistic by default, server enforces
  return data.capabilities.includes(key);
}
